/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molecular Weight Calculator`)
};

const es_mw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Peso Molecular`)
};

const de_mw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molekulargewichtsrechner`)
};

const nl_mw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molecuulgewichtcalculator`)
};

const fr_mw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de masse moléculaire`)
};

const it_mw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore di peso molecolare`)
};

const pt_br2_mw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Peso Molecular`)
};

const pt_mw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Massa Molecular`)
};

const ja_mw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分子量計算ツール`)
};

const zh_mw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分子量计算器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mw_h1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mw_h1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mw_h1", locale)
	if (locale === "en") return en_mw_h1(inputs)
	if (locale === "es") return es_mw_h1(inputs)
	if (locale === "de") return de_mw_h1(inputs)
	if (locale === "nl") return nl_mw_h1(inputs)
	if (locale === "fr") return fr_mw_h1(inputs)
	if (locale === "it") return it_mw_h1(inputs)
	if (locale === "pt-BR") return pt_br2_mw_h1(inputs)
	if (locale === "pt") return pt_mw_h1(inputs)
	if (locale === "ja") return ja_mw_h1(inputs)
	return zh_mw_h1(inputs)
};